import { Box, Grid, GridItem, Stack, Text, useColorMode } from '@chakra-ui/react';
import React, { useEffect, useState, useMemo } from 'react';

import { ReactComponent as BookFillIcon } from '../icons/book.fill.svg';
import { ReactComponent as BookIcon } from '../icons/book.svg';
import { ReactComponent as MatchingFillIcon } from '../icons/matching.fill.svg';
import { ReactComponent as MatchingIcon } from '../icons/matching.svg';

import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import useUserQuery from '../components/api/queries/useUserQuery';
import { ReactComponent as ProfileFillIcon } from '../icons/profile.fill.svg';
import { ReactComponent as ProfileIcon } from '../icons/profile.line.svg';
import { Chat, ChatFill } from '@peacecover/icon';
import { useFeatureEnabled } from '../domains/features/ui/hooks/useFeatureEnabled';
import { FEATURE_KEYS } from '../domains/features/constants';

const ENABLED_COLOR = 'fill-primary-light dark:fill-primary-dark';
const DISABLED_COLOR = 'fill-main-light-4 dark:fill-main-dark-4';

export default function HomeBottomNav({ tabIndex }) {
  const { colorMode } = useColorMode();
  const navigate = useNavigate();
  const [selectedTabIndex, setSelectedTabIndex] = useState(tabIndex || 0);

  const user = useUserQuery();
  const { data: cardReviewFeature } = useFeatureEnabled(FEATURE_KEYS.CARD_REVIEW);
  const isCardReviewEnabled = cardReviewFeature?.featureFlag?.enabled ?? false;

  useEffect(() => {
    setSelectedTabIndex(tabIndex);
  }, [tabIndex]);

  const setEnabledColor = (isEnabled) => {
    return isEnabled
      ? 'text-primary-light dark:text-primary-dark'
      : 'text-main-light-4 dark:text-main-dark-4';
  };

  const TABS = useMemo(() => {
    const ALL_TABS = [
      {
        index: 0,
        inActiveIcon: <BookIcon className={DISABLED_COLOR} width={26} height={26} />,
        activeIcon: <BookFillIcon className={ENABLED_COLOR} width={26} height={26} />,
        name: t('tabs.collections')
      },
      {
        index: 1,
        inActiveIcon: <MatchingIcon className={DISABLED_COLOR} width={26} height={26} />,
        activeIcon: <MatchingFillIcon className={ENABLED_COLOR} width={26} height={26} />,
        name: t('tabs.tradingPhotoCard'),
        featureKey: FEATURE_KEYS.CARD_REVIEW,
        inverted: true
      },
      {
        index: 2,
        inActiveIcon: <Chat className="text-text-main-lv4" width={26} height={26} />,
        activeIcon: (
          <ChatFill className="text-primary-light dark:text-primary-dark" width={26} height={26} />
        ),
        name: isCardReviewEnabled ? '베티' : t('tabs.chat')
      },
      // {
      //   index: 3,
      //   inActiveIcon: <CartIcon className={DISABLED_COLOR} width={24} height={24} />,
      //   activeIcon: <CartFillIcon className={ENABLED_COLOR} width={24} height={24} />,
      //   name: t('tabs.store')
      // },
      {
        index: 4,
        inActiveIcon: <ProfileIcon className={DISABLED_COLOR} width={26} height={26} />,
        activeIcon: <ProfileFillIcon className={ENABLED_COLOR} width={26} height={26} />,
        name: t('tabs.profile')
      }
    ];

    return ALL_TABS.filter((tab) => {
      if (tab.featureKey && tab.inverted) {
        // inverted가 true면 feature가 활성화된 경우 숨김
        return !isCardReviewEnabled;
      }
      return true;
    });
  }, [isCardReviewEnabled]);

  const onClickTabButton = (index) => {
    setSelectedTabIndex(index);
    if (selectedTabIndex === index) {
      return window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    switch (index) {
      case 0:
        return navigate('/collections');
      case 1:
        return navigate('/tradings/photo_cards');
      case 2:
        return navigate('/home');
      // case 3: {
      //   const baseUrl = isKorean()
      //     ? 'https://store.pocapan.com'
      //     : 'https://storeglobal.pocapan.com';
      //   window.location.href = `${baseUrl}/?pocapan_user_id=${user?.userId}`;
      //   return;
      // }
      case 4:
        return navigate('/my');
      default:
        return;
    }
  };

  return (
    <Box
      maxW={'xl'}
      className={`${
        colorMode === 'dark' ? 'darkBottomNavbar' : 'bottomNavbar'
      } dark:!bg-background-elevated safeAreaPaddingBottom z-[999]`}
      style={
        colorMode === 'dark'
          ? { filter: 'drop-shadow(0px 0px 15px rgba(0, 0, 0, 0.3))' }
          : { filter: 'drop-shadow(0px 0px 15px rgba(0, 0, 0, 0.1))' }
      }
    >
      <Grid
        className="bg-background-light dark:bg-[#151619]"
        // className="bg-background-light dark:bg-background-dark"
        templateColumns={`repeat(${TABS.length}, 1fr)`}
        alignItems={'center'}
        paddingStart="10px"
        paddingEnd="10px"
      >
        {TABS.map((tab) => {
          return (
            <GridItem
              key={tab.index}
              paddingTop={'13px'}
              paddingBottom={'10px'}
              colSpan={1}
              onClick={() => onClickTabButton(tab.index)}
              style={{
                WebkitTapHighlightColor: 'rgba(0,0,0,0)',
                outline: 'none'
              }}
            >
              <Stack align="stretch" alignItems={'center'} spacing={'2px'}>
                {selectedTabIndex === tab.index ? tab.activeIcon : tab.inActiveIcon}
                <Text
                  className={setEnabledColor(selectedTabIndex === tab.index)}
                  fontSize={'11px'}
                  fontWeight={500}
                >
                  {tab.name}
                </Text>
              </Stack>
            </GridItem>
          );
        })}
      </Grid>
    </Box>
  );
}
